/**
 * @desc: - 倒计时组件
 * @param  {[string]} className : [背景className]
 * @param  {[bool]}   status : [运动状态]
 * @param  {[number]} time :  [倒计时数字]
 * @author: circle
 */
import React from 'react';
import ReactDOM from 'react-dom'
export default class CountDown extends React.Component {

  constructor(props) {
    super(props);
  }
 
  render() {
    let {className, time} = this.props
    return (
      <div>
        <div className={className || 'time'}>
          <span>{time}</span>
        </div>
      </div>
    );
  }
}